// This file was automatically generated from render.chartFeedItemNew.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.chartFeedItemNew');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appchart.letters.unreadAlertNotification');
goog.require('el8.template.appshared.docTags');
goog.require('el8.template.core');
goog.require('el8.template.ptdata.letterReceiptsNew');
goog.require('el8.template.ptdata.lettersNew');
goog.require('el8.template.ptdata.model.attachment');
goog.require('el8.template.ptdata.model.dcMedOrder');
goog.require('el8.template.ptdata.model.medOrder');
goog.require('el8.template.ptdata.model.message');
goog.require('el8.template.ptdata.model.note');
goog.require('el8.template.ptdata.model.order');
goog.require('el8.template.ptdata.model.order.referral');
goog.require('el8.template.ptdata.model.order');
goog.require('el8.template.ptdata.plrCollaboratorNotifications');
goog.require('el8.template.ptdata.prenatalFlowsheets');
goog.require('el8.template.ptdata.reports');
goog.require('el8.template.render.chartFeedItemNew.visitNoteContent');
goog.require('el8.template.render.chartFeedItemNew.visitNoteTemplate.oneCol');
goog.require('el8.template.render.chartFeedItemNew.visitNoteTemplate.twoCol');
goog.require('el8.template.render.chartReqActFeedItemSharedNew');
goog.require('el8.template.render.signOff');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.dateColumn = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedItemColDate" data-dd-privacy="allow"><div class="el8FeedItemMonthDay">', (soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyMonthDay(soy.$$escapeHtml(opt_data.feedDate)) : ''), '</div><div class="el8FeedItemYear">', (soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyYear(soy.$$escapeHtml(opt_data.feedDate)) : ''), '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.reportItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight report-item"><div class="el8FeedItemNewWrapper">');
  if (opt_data.sortByProviderActivity) {
    el8.template.render.chartFeedItemNew.dateColumn(soy.$$augmentData(opt_data, {feedDate: opt_data.feedDate}), output);
  } else {
    el8.template.render.chartFeedItemNew.dateColumn(soy.$$augmentData(opt_data, {feedDate: opt_data.report.documentDate}), output);
  }
  output.append('<div class="el8FeedItemColIcon">', (opt_data.report.reportType == 'lab') ? '<div class="el8ChartFeedIconLabReport"></div>' : (opt_data.report.formCollection) ? '<div class="el8ChartFeedIconFormCollection"></div>' : '<div class="el8ChartFeedIconReport"></div>', '</div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine"><a class="el8FeedItemColMainTopLineLink details-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.ptdata.reports.summary(soy.$$augmentData(opt_data.report, {doHighlight: true}), output);
  output.append('</a>');
  el8.template.appshared.docTags.feedIcon({docTags: opt_data.report.docTags, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>');
  if (opt_data.report.abnormalResultNames.length) {
    output.append('<div class="el8FeedColMainLine">');
    el8.template.ptdata.reports.abnormalSummary(opt_data.report, output);
    output.append('</div>');
  }
  if (opt_data.indexItem.snippets && opt_data.indexItem.snippets.length || opt_data.labResults && opt_data.labResults.length) {
    output.append('<div class="el8FeedItemSnippetText">');
    if (opt_data.indexItem.snippets && opt_data.indexItem.snippets.length) {
      var snippetList23341 = opt_data.indexItem.snippets;
      var snippetListLen23341 = snippetList23341.length;
      for (var snippetIndex23341 = 0; snippetIndex23341 < snippetListLen23341; snippetIndex23341++) {
        var snippetData23341 = snippetList23341[snippetIndex23341];
        output.append('<div class="el8Relative"><pre>...', soy.$$escapeHtml(snippetData23341), '...</pre></div>');
      }
    }
    if (opt_data.labResults && opt_data.labResults.length) {
      var labResultList23348 = opt_data.labResults;
      var labResultListLen23348 = labResultList23348.length;
      for (var labResultIndex23348 = 0; labResultIndex23348 < labResultListLen23348; labResultIndex23348++) {
        var labResultData23348 = labResultList23348[labResultIndex23348];
        output.append('<div class="el8Relative">', soy.$$escapeHtml(labResultData23348.labTest), ': ', soy.$$escapeHtml(labResultData23348.value), ' ', soy.$$escapeHtml(labResultData23348.units), (opt_data.labResults.documentingPersonnelType) ? (opt_data.labResults.documentingPersonnelType == 'Physician') ? '<div class="el8PhysicianInputIconSmall el8SnippetIconSmallPosition"></div>' : '<div class="el8StaffInputIconSmall el8SnippetIconSmallPosition"></div>' : '', '</div>');
      }
    }
    output.append('</div>');
  }
  output.append((opt_data.sortByProviderActivity) ? (opt_data.report.documentDate) ? '<div class="el8FeedColMainLine">Report Dated ' + (soy.$$escapeHtml(opt_data.report.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.report.documentDate)) : '') + '</div>' : '' : (opt_data.feedDate) ? '<div class="el8FeedColMainLine">Reviewed ' + (soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.feedDate)) : '') + '</div>' : '');
  if (opt_data.report.noteItems.length) {
    output.append('<div class="el8FeedColMainLine">');
    el8.template.ptdata.reports.noteListSummaryNEW(opt_data.report, output);
    output.append('</div>');
  }
  if (opt_data.referringThreads.length > 0) {
    var threadList23387 = opt_data.referringThreads;
    var threadListLen23387 = threadList23387.length;
    for (var threadIndex23387 = 0; threadIndex23387 < threadListLen23387; threadIndex23387++) {
      var threadData23387 = threadList23387[threadIndex23387];
      output.append('<div class="el8FeedColMainLine">');
      el8.template.ptdata.model.message.referencedFeedSummary(threadData23387, output);
      output.append('</div>');
    }
  }
  output.append('<div class="el8FeedItemColSource">');
  el8.template.render.chartFeedItemNew.plrImportableSource(soy.$$augmentData(opt_data, {isConfidential: opt_data.report.isConfidential}), output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.orderItemBase = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  if (opt_data.sortByProviderActivity) {
    el8.template.render.chartFeedItemNew.dateColumn(soy.$$augmentData(opt_data, {feedDate: opt_data.feedDate}), output);
  } else {
    el8.template.render.chartFeedItemNew.dateColumn(soy.$$augmentData(opt_data, {feedDate: opt_data.order.documentDate}), output);
  }
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconOrder"></div></div><div class="el8FeedItemColMain">');
  el8.template.render.chartFeedItemNew.actionsSection(opt_data, output);
  output.append('<div class="el8FeedItemColMainTopLine">');
  if (opt_data.order.modelClass == 'LabOrder' && opt_data.order.submissionState == 'failed') {
    output.append('<a class="el8FeedItemColMainTopLineLink details-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">Order: ');
    el8.template.ptdata.model.order.orderFeedSummary({order: opt_data.order, noExtraInfo: true}, output);
    output.append('</a><span class="el8FeedItemAbnormalText" style="padding: 6px">This electronic order failed. Use the ‘Actions’ menu to ‘reorder’ or call the servicing lab directly.</span></p>');
  } else {
    output.append('<a class="el8FeedItemColMainTopLineLink ', (opt_data.isRA) ? 'unsigned-order-trigger' : 'details-trigger', '" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">', (opt_data.isRA) ? 'In Progress: ' : '', (el8Globals.FEATURES.BiDiLabs) ? ((opt_data.order.currentState == 'outstanding') ? '<div class="el8FeedItemNoticeText">Outstanding</div>' : '') + ((opt_data.order.currentState == 'cancelled') ? '<span class="el8Strike el8999">' : '') : '');
    if (opt_data.order.modelClass == 'ReferralOrder') {
      output.append('Order: ');
      el8.template.ptdata.model.order.referral.feedSummary({order: opt_data.order, noExtraInfo: true}, output);
    } else {
      output.append('Order: ');
      el8.template.ptdata.model.order.orderFeedSummary({order: opt_data.order, noExtraInfo: true}, output);
    }
    output.append((el8Globals.FEATURES.BiDiLabs && opt_data.order.currentState == 'cancelled') ? '</span>' : '', '</a>');
  }
  output.append('</div>', (opt_data.order.dateForTest) ? '<div class="el8FeedColMainLine">Do test on ' + (soy.$$escapeHtml(opt_data.order.dateForTest)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.dateForTest)) : '') + '</div>' : '');
  if (el8Globals.FEATURES.BiDiLabs) {
    el8.template.ptdata.model.order.reminderStatus({order: opt_data.order}, output);
  }
  output.append('<div class="el8FeedItemColSource">');
  el8.template.render.chartFeedItemNew.plrImportableSource(soy.$$augmentData(opt_data, {isConfidential: opt_data.order.isConfidential}), output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.orderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItemNew.orderItemBase(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.medOrderItemBase = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon">');
  el8.template.ptdata.model.medOrder.chartFeedIconNew(opt_data.order, output);
  output.append('</div><div class="el8FeedItemColMain">');
  el8.template.render.chartFeedItemNew.actionsSection(opt_data, output);
  el8.template.ptdata.model.medOrder.feedSummaryNew(soy.$$augmentData(opt_data.order, {isRA: opt_data.isRA, highlight: true, hasActions: opt_data.hasActions, feedItemId: opt_data.feedItemId}), output);
  output.append((opt_data.order.startDate) ? '<div class="el8FeedColMainLine">Started on ' + (soy.$$escapeHtml(opt_data.order.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.startDate)) : '') + '</div>' : '');
  if (opt_data.order.pharmacyInstructions || opt_data.order.isAllowSubstitutions) {
    output.append('<div class="el8FeedColMainLine">');
    el8.template.ptdata.model.medOrder.pharmacyInstructionsSummaryNew(opt_data.order, output);
    output.append((! opt_data.order.includeStartDate && opt_data.order.isPostDated) ? ' (to start on: ' + (soy.$$escapeHtml(opt_data.order.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.startDate)) : '') + ')' : (opt_data.order.includeStartDate) ? ' (start on: ' + (soy.$$escapeHtml(opt_data.order.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.startDate)) : '') + ')' : '', '</div>');
  }
  output.append((opt_data.order.latestFillStatus == 'AH') ? '<div class="el8FeedColMainLine">Last Dispensed on ' + (soy.$$escapeHtml(opt_data.order.latestFillDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.latestFillDate)) : '') + ((opt_data.order.latestFillNote) ? ' - ' + soy.$$escapeHtml(opt_data.order.latestFillNote) : '') + '</div>' : (opt_data.order.latestFillStatus == 'AJ') ? '<div class="el8FeedColMainLine">Last Dispensed (partially) on ' + (soy.$$escapeHtml(opt_data.order.latestFillDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.latestFillDate)) : '') + ((opt_data.order.latestFillNote) ? ' - ' + soy.$$escapeHtml(opt_data.order.latestFillNote) : '') + '</div>' : (opt_data.order.latestFillStatus == 'AK') ? '<div class="el8FeedColMainLine">Not Dispensed as of ' + (soy.$$escapeHtml(opt_data.order.latestFillDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.latestFillDate)) : '') + ((opt_data.order.latestFillNote) ? ' - ' + soy.$$escapeHtml(opt_data.order.latestFillNote) : '') + '</div>' : (opt_data.order.latestFillStatus == 'AL') ? '<div class="el8FeedColMainLine">Transferred on ' + (soy.$$escapeHtml(opt_data.order.latestFillDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.latestFillDate)) : '') + ((opt_data.order.latestFillNote) ? ' - ' + soy.$$escapeHtml(opt_data.order.latestFillNote) : '') + '</div>' : '', '</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.medOrderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItemNew.medOrderItemBase(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.dcMedOrderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconDCMed"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine"><a class="el8FeedItemColMainTopLineLink details-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.ptdata.model.dcMedOrder.feedSummaryNew(soy.$$augmentData(opt_data.order, {highlight: true}), output);
  output.append('</a></div><div class="el8FeedColMainLine">');
  el8.template.ptdata.model.dcMedOrder.feedReasonAndDateNew(opt_data.order, output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.nonvisitNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew el8FeedItemNonVisitNote am-highlight nonvisit-note-item" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconNonVisitNote"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine">');
  el8.template.ptdata.model.note.nonvisitNoteDescription(opt_data, output);
  output.append(' on ', (soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.feedDate)) : ''), ' at ', (soy.$$escapeHtml(opt_data.feedDate)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.feedDate)) : ''));
  el8.template.appshared.docTags.feedIcon(opt_data, output);
  output.append('</div>', (opt_data.associatedEmail) ? ((opt_data.associatedEmail.from_email) ? '<p class="el8AppText el8Ellipsis">From: ' + soy.$$escapeHtml(opt_data.associatedEmail.from_email) + '</p>' : '') + ((opt_data.associatedEmail.subject) ? '<p class="el8AppText el8Ellipsis">Re: ' + soy.$$escapeHtml(opt_data.associatedEmail.subject) + '</p>' : '') : '');
  el8.template.render.chartFeedItemNew.nonvisitNoteCore(opt_data, output);
  output.append('<div class="el8FeedItemColSource">');
  el8.template.render.chartFeedItemNew.plrImportableSource(opt_data, output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.nonvisitNoteCore = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedItemColMainContainer padv10">');
  if (opt_data.images.length > 0) {
    output.append('<ul class="nonvisit-image-section">');
    var imageList23603 = opt_data.images;
    var imageListLen23603 = imageList23603.length;
    for (var imageIndex23603 = 0; imageIndex23603 < imageListLen23603; imageIndex23603++) {
      var imageData23603 = imageList23603[imageIndex23603];
      output.append('<li class="images_', soy.$$escapeHtml(imageIndex23603), ' docImage">', (opt_data.directlyRenderImages) ? '<img class="el8MaxWidth100" src="' + soy.$$escapeHtml(imageData23603) + '" />' : '<div data-src="' + soy.$$escapeHtml(imageData23603) + '" class="image-item imageLoading" data-id="' + soy.$$escapeHtml(opt_data.id) + '"></div>', '</li>');
    }
    output.append('</ul>');
  }
  if (opt_data.bullets.length == 1) {
    output.append('<p class="el8Preserve el8WrapWord mb10">', (opt_data.bullets[0].text) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.bullets[0].text)) : soy.$$escapeHtml(opt_data.bullets[0].text)) : (opt_data.bullets[0].safeText) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(opt_data.bullets[0].safeText) : opt_data.bullets[0].safeText) : '', '</p>');
  } else {
    output.append('<ol class="el8FieldShortLabelPadding mb10">');
    var bList23635 = opt_data.bullets;
    var bListLen23635 = bList23635.length;
    for (var bIndex23635 = 0; bIndex23635 < bListLen23635; bIndex23635++) {
      var bData23635 = bList23635[bIndex23635];
      el8.template.core.listItem(bData23635, output);
    }
    output.append('</ol>');
  }
  if (opt_data.ownedDocs.length) {
    output.append('<p class="el8AppLightText padv5">Orders:</p><ol class="el8FieldShortLabelPadding mb10">');
    var itemList23642 = opt_data.ownedDocs;
    var itemListLen23642 = itemList23642.length;
    for (var itemIndex23642 = 0; itemIndex23642 < itemListLen23642; itemIndex23642++) {
      var itemData23642 = itemList23642[itemIndex23642];
      el8.template.core.listItem(soy.$$augmentData(itemData23642, {triggerClass: ! opt_data.isImportedNote ? 'item-details-trigger itemTrigger' : null}), output);
    }
    output.append('</ol>');
  }
  if (opt_data.referencedDocs.length) {
    output.append('<p class="el8AppLightText padv5">Documents Referenced:</p><ol class="el8FieldShortLabelPadding mb10">');
    var itemList23650 = opt_data.referencedDocs;
    var itemListLen23650 = itemList23650.length;
    for (var itemIndex23650 = 0; itemIndex23650 < itemListLen23650; itemIndex23650++) {
      var itemData23650 = itemList23650[itemIndex23650];
      el8.template.core.listItem(soy.$$augmentData(itemData23650, {triggerClass: ! opt_data.isImportedNote ? 'item-details-trigger itemTrigger' : null}), output);
    }
    output.append('</ol>');
  }
  if (opt_data.vitalsCollections.length) {
    output.append('<p class="el8AppLightText padv5">Vitals:</p><ol class="el8FieldShortLabelPadding mb10">');
    var itemList23658 = opt_data.vitalsCollections;
    var itemListLen23658 = itemList23658.length;
    for (var itemIndex23658 = 0; itemIndex23658 < itemListLen23658; itemIndex23658++) {
      var itemData23658 = itemList23658[itemIndex23658];
      el8.template.core.listItem(itemData23658, output);
    }
    output.append('</ol>');
  }
  if (opt_data.attachments.length) {
    output.append((opt_data.typeName == 'direct') ? '<p class="el8AppLightText padv5">Attachment' + ((opt_data.attachments.length > 1) ? 's' : '') + ':</p>' : '<p class="el8AppLightText padv5">Original File:</p>', '<ol class="el8FieldShortLabelPadding mb10">');
    var itemList23674 = opt_data.attachments;
    var itemListLen23674 = itemList23674.length;
    for (var itemIndex23674 = 0; itemIndex23674 < itemListLen23674; itemIndex23674++) {
      var itemData23674 = itemList23674[itemIndex23674];
      if (itemData23674.contentType == 'application/xml') {
        output.append('<li class="el8BulletText">Patient Summary C-CDA</li>');
      } else {
        output.append('<li class="el8BulletText"><a target="_blank" rel="noopener" href="', soy.$$escapeHtml(itemData23674.downloadUrl), '" tabindex="-1">');
        el8.template.ptdata.model.attachment.summary(itemData23674, output);
        output.append('</a></li>');
      }
    }
    output.append('</ol>');
  }
  if (opt_data.signDate) {
    el8.template.render.signOff.feedSummary(opt_data, output);
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.messageThread = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew el8FeedItemMessageThread am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconMessage"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div>');
  if (opt_data.useNewMessages) {
    output.append('<div class="el8FeedItemColMainTopLine">');
    var memberList23701 = opt_data.members;
    var memberListLen23701 = memberList23701.length;
    for (var memberIndex23701 = 0; memberIndex23701 < memberListLen23701; memberIndex23701++) {
      var memberData23701 = memberList23701[memberIndex23701];
      output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(memberData23701.name)) : soy.$$escapeHtml(memberData23701.name)), (! (memberIndex23701 == memberListLen23701 - 1)) ? ', ' : '');
    }
    output.append('</div><div id="', soy.$$escapeHtml(opt_data.feedId), '-messages"></div>');
  } else {
    output.append('<div class="el8FeedItemColMainTopLine">');
    var memberList23713 = opt_data.members;
    var memberListLen23713 = memberList23713.length;
    for (var memberIndex23713 = 0; memberIndex23713 < memberListLen23713; memberIndex23713++) {
      var memberData23713 = memberList23713[memberIndex23713];
      output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(memberData23713.name)) : soy.$$escapeHtml(memberData23713.name)), (! (memberIndex23713 == memberListLen23713 - 1)) ? ', ' : '');
    }
    output.append('</div><div class="el8MessageWrapper">');
    var messageList23721 = opt_data.messages;
    var messageListLen23721 = messageList23721.length;
    for (var messageIndex23721 = 0; messageIndex23721 < messageListLen23721; messageIndex23721++) {
      var messageData23721 = messageList23721[messageIndex23721];
      output.append('<div class="el8MessageContent"><div class="el8MsgAvatar"><img src="/user/', soy.$$escapeHtml(messageData23721.senderId), '/photo/profile/24/24/" /></div><div class="el8MessageMetaData"><span class="el8MessageAuthor ', (messageData23721.isPhysician) ? 'el8PhysicianText' : 'el8StaffTextNew', '">', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(messageData23721.senderName)) : soy.$$escapeHtml(messageData23721.senderName)), '</span><span class="el8MessageTimeStamp">', (soy.$$escapeHtml(messageData23721.sendDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(messageData23721.sendDate)) : ''), '</span></div><div class="el8MessageText el8Preserve ', (messageData23721.isPhysician) ? 'åel8PhysicianText' : 'el8StaffTextNew', '">', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(messageData23721.body)) : soy.$$escapeHtml(messageData23721.body)), '</div>', (messageData23721.docId) ? '<p class="el8AppText el8Ellipsis">Re: <a class="item-details-trigger" data-id="' + soy.$$escapeHtml(messageData23721.docId) + '">' + messageData23721.docSummary + '</a></p>' : (messageData23721.docPlaceholder) ? '<p class="el8AppText el8Ellipsis">Re: ' + soy.$$escapeHtml(messageData23721.docPlaceholder) + '</p>' : '', '</div>');
    }
    output.append('</div>');
  }
  if (opt_data.signDate && ! el8Globals.FEATURES.NewOfficeMessages) {
    output.append('<div class="mb10">');
    el8.template.render.signOff.feedSummary(soy.$$augmentData(opt_data, {signUserName: opt_data.signOffUser}), output);
    output.append('</div>');
  }
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNoteDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="visit-note-description">', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.description)) : soy.$$escapeHtml(opt_data.description)), '</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew el8FeedItemVisitNote ', (opt_data.isAmendPreview || ! opt_data.signDate) ? 'el8FeedItemVisitNoteNonFinal' : '', ' visit-note-item" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconVisitNote"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine"><a class="visit-note-toggle-collapse-trigger">', (! opt_data.signDate) ? 'PREVIEW: ' : '');
  el8.template.render.chartFeedItemNew.visitNoteDescription(opt_data, output);
  output.append(' ', soy.$$escapeHtml(opt_data.formattedFeedDate), (opt_data.edits && opt_data.edits.length > 0) ? '<span class="el8AttentionText el8StandardFontSize ml5"> (amended on ' + ((opt_data.edits[opt_data.edits.length - 1].signDate) ? (soy.$$escapeHtml(opt_data.edits[opt_data.edits.length - 1].signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.edits[opt_data.edits.length - 1].signDate)) : '') : (soy.$$escapeHtml(opt_data.edits[opt_data.edits.length - 1].createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.edits[opt_data.edits.length - 1].createDate)) : '')) + ')</span>' : '');
  el8.template.appshared.docTags.feedIcon(opt_data, output);
  output.append('</a>', (! opt_data.signDate) ? '<a class="el8FeedItemHeaderLinkNew ml10 visit-note-preview-edit-trigger">Edit</a>' : '', ' <a class="el8FeedItemHeaderLinkNew ml10 visit-note-toggle-collapse-status visit-note-toggle-collapse-trigger">collapse status holder</a></div>');
  el8.template.render.chartFeedItemNew.visitNoteCore(opt_data, output);
  output.append('<div class="el8FeedItemColSource">');
  el8.template.render.chartFeedItemNew.plrImportableSource(opt_data, output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.visitNoteCore = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedColMainLine">CC/Reason: ', (opt_data.reason.textReplaced) ? '<span class="el8Strike">' + soy.$$escapeHtml(opt_data.reason.textReplaced) + '</span> ' : '', (opt_data.reason.isEdit) ? '<span class="el8Edit">' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.reason.text)) : soy.$$escapeHtml(opt_data.reason.text)) + '</span>' : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.reason.text)) : soy.$$escapeHtml(opt_data.reason.text)), '</div><div class="el8FeedColMainLine">');
  el8.template.render.chartFeedItemNew.visitNoteContent.sectionPreOp({dateprocedure: opt_data.dateprocedure, consultant: opt_data.consultant, attending: opt_data.attending}, output);
  output.append('</div><div class="el8FeedItemColMainContainer">');
  if (opt_data.templateClass == 'oneCol') {
    el8.template.render.chartFeedItemNew.visitNoteTemplate.oneCol.content(opt_data, output);
  } else {
    el8.template.render.chartFeedItemNew.visitNoteTemplate.twoCol.content(opt_data, output);
  }
  if (opt_data.images.length || opt_data.attachments.length) {
    output.append('<p class="el8SmallHeading">Attachments</p>');
    el8.template.render.chartFeedItemNew.visitNoteContent.sectionImages({images: opt_data.images, directlyRenderImages: opt_data.directlyRenderImages}, output);
    if (opt_data.attachments.length) {
      output.append('<div><p class="el8SmallHeading">Original File:</p><ol>');
      var itemList23850 = opt_data.attachments;
      var itemListLen23850 = itemList23850.length;
      for (var itemIndex23850 = 0; itemIndex23850 < itemListLen23850; itemIndex23850++) {
        var itemData23850 = itemList23850[itemIndex23850];
        output.append('<li class="el8BulletText"><a class="rightIndent" target="_blank" rel="noopener" href="', soy.$$escapeHtml(itemData23850.downloadUrl), '" tabindex="-1">');
        el8.template.ptdata.model.attachment.summary(itemData23850, output);
        output.append('</a></li>');
      }
      output.append('</ol></div>');
    }
  }
  el8.template.render.chartFeedItemNew.visitNoteContent.sectionBilling(soy.$$augmentData(opt_data.bill, {timeWithPatient: opt_data.timeWithPatient, timeDocumenting: opt_data.timeDocumenting, checkout: opt_data.checkout, muInfo: opt_data.muInfo, amendmentRequest: opt_data.amendmentRequest, showMuInfo: opt_data.showMuInfo}), output);
  output.append('<div class="mb20">');
  if (opt_data.signDate) {
    el8.template.render.signOff.feedSummary(opt_data, output);
  }
  if (opt_data.edits && ! el8Globals.FEATURES.CoSignature) {
    var eList23871 = opt_data.edits;
    var eListLen23871 = eList23871.length;
    for (var eIndex23871 = 0; eIndex23871 < eListLen23871; eIndex23871++) {
      var eData23871 = eList23871[eIndex23871];
      output.append('<div class="el8FeedItemSmallLightText collapsible-section">', (eData23871.signDate) ? 'Amended and signed by ' + soy.$$escapeHtml(eData23871.signUserName) + ' on ' + (soy.$$escapeHtml(eData23871.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(eData23871.signDate)) : '') + ((! opt_data.isImportedNote) ? '<a class="edit-changes-trigger ml5" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '" _id="' + soy.$$escapeHtml(eData23871.id) + '">view changes</a>' : '') : 'In-progress amendment created by ' + soy.$$escapeHtml(eData23871.createUserName) + ' on ' + (soy.$$escapeHtml(eData23871.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(eData23871.createDate)) : ''), '</div>');
    }
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.importedNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconReport"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine"><a class="el8FeedItemColMainTopLineLink details-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  if (opt_data.modelClass == 'VisitNote') {
    el8.template.ptdata.model.note.importedVisitDescription(opt_data, output);
  } else if (opt_data.modelClass == 'NonvisitNote') {
    el8.template.ptdata.model.note.importedNonvisitDescription(opt_data, output);
  }
  output.append('</a>');
  el8.template.appshared.docTags.feedIcon(opt_data, output);
  output.append('</div>', (opt_data.modelClass == 'VisitNote' && opt_data.reason) ? '<div class="el8FeedColMainLine">CC/Reason: ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.reason.text)) : soy.$$escapeHtml(opt_data.reason.text)) + '</div>' : '', '<div class="el8FeedItemColSource">');
  el8.template.render.chartFeedItemNew.plrImportableSource(opt_data, output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.denialMedOrder = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconDenyRefill"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine">Denied Refill Request for ', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.item.medication)) : soy.$$escapeHtml(opt_data.item.medication)), (opt_data.item.refills) ? ' #' + soy.$$escapeHtml(opt_data.item.refills) : '', '</div>', (opt_data.item.note || opt_data.item.reason) ? '<div class="el8FeedColMainLine">Reason: ' + soy.$$escapeHtml(opt_data.item.note) + ((opt_data.item.reason) ? ' [' + soy.$$escapeHtml(opt_data.item.reason) + ']' : '') + '</div>' : '');
  if (opt_data.item.state == 'error' || opt_data.item.state == 'failure') {
    output.append('<div class="el8FeedColMainLine el8AttentionText">Denial not received');
    el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data.item, {preposition: 'by'}), output);
    output.append((opt_data.item.denialReason == 'E') ? '.  Refill request was dismissed because response cannot be sent electronically.' : ' due to error.', '</div>');
  } else if (opt_data.item.state == 'new' || opt_data.item.state == 'sending' || opt_data.item.state == 'sent') {
    output.append('<div class="el8FeedColMainLine">Being sent');
    el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data.item, {preposition: 'to'}), output);
    output.append('...</div>');
  } else if (opt_data.item.state == 'pending_complete') {
    output.append('<div class="el8FeedColMainLine">Sent');
    el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data.item, {preposition: 'to'}), output);
    output.append(' successfully.</div>');
  } else if (opt_data.item.state == 'complete') {
    output.append('<div class="el8FeedColMainLine">Sent');
    el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data.item, {preposition: 'to'}), output);
    output.append(' successfully.<a class="explain-surescripts-trigger">*</a></div>');
  }
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.rxHistoryDownload = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconRxDownload"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine"><a class="view-fills-trigger" data-id="', soy.$$escapeHtml(opt_data.summaryItem.id), '">', soy.$$escapeHtml(opt_data.summaryItem.description), '</a></div>', (opt_data.summaryItem.eligPbmName) ? '<div class="el8FeedColMainLine">Source: ' + soy.$$escapeHtml(opt_data.summaryItem.eligPbmName) + '</div>' : '', '</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.letterItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew el8FeedItemLetter am-highlight letter-item" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '" data-id="', soy.$$escapeHtml(opt_data.letter.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon">');
  el8.template.ptdata.lettersNew.feedIcon(opt_data.letter, output);
  el8.template.ptdata.lettersNew.letterMetadataCounts(opt_data.letter, output);
  output.append('</div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainContainer">');
  el8.template.ptdata.lettersNew.signedSummaryNew(opt_data, output);
  output.append('</div><div>');
  el8.template.ptdata.lettersNew.secondarySection(opt_data, output);
  output.append('</div>');
  if (opt_data.letter.signDate) {
    output.append('<div class="mb10">');
    el8.template.render.signOff.feedSummary(opt_data.letter, output);
    output.append('</div>');
  }
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.letterReceipt = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew el8FeedItemLetterReceipt am-highlight letter-receipt-item" data-id="', soy.$$escapeHtml(opt_data.letterReceipt.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon">');
  el8.template.ptdata.letterReceiptsNew.feedIcon(opt_data.letterReceipt, output);
  el8.template.ptdata.letterReceiptsNew.metadataCounts(opt_data.letterReceipt, output);
  output.append('</div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainContainer">');
  el8.template.ptdata.letterReceiptsNew.summaryNew(opt_data.letterReceipt, output);
  output.append('</div><div class="el8FeedItemColMainContainer">');
  el8.template.ptdata.letterReceiptsNew.secondarySection(opt_data.letterReceipt, output);
  output.append('</div>');
  if (opt_data.letterReceipt.signDate) {
    output.append('<div class="mb10">');
    el8.template.render.signOff.feedSummary(opt_data.letterReceipt, output);
    output.append('</div>');
  }
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.unreadLetterNotificationItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon">', (opt_data.letter.isSendToPatient) ? '<div class="el8ChartFeedIconPtLetterAlert"></div>' : '<div class="el8ChartFeedIconLetterAlert"></div>', '</div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine el8Ellipsis">Not opened by recipient -- ');
  el8.template.appchart.letters.unreadAlertNotification.feedSummary(soy.$$augmentData(opt_data, {linkToDetail: true}), output);
  output.append('</div>');
  if (opt_data.unreadLetterNotification.actionTaken != 'acknowledged') {
    output.append('<div class="el8FeedColMainLine">');
    el8.template.appchart.letters.unreadAlertNotification.chartFeedItemText(opt_data, output);
    output.append('</div>');
  }
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.xmlSummaryItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconPtSummary"></div></div><div class="el8FeedItemColMain">');
  el8.template.render.chartFeedItemNew.actionsSection(opt_data, output);
  output.append('<div class="el8FeedItemColMainTopLine"><a class="view-xml-summary" data-id="', soy.$$escapeHtml(opt_data.summaryItem.id), '">Patient Summary (', (opt_data.summaryItem.authorName) ? soy.$$escapeHtml(opt_data.summaryItem.authorName) : 'Unknown Author', ')</a></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.hl7MessageItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconPtSummary"></div></div><div class="el8FeedItemColMain">');
  el8.template.render.chartFeedItemNew.actionsSection(opt_data, output);
  output.append('<div class="el8FeedItemColMainTopLine"><a class="view-hl7-message" data-id="', soy.$$escapeHtml(opt_data.messageItem.id), '">Patient Immunization Summary</a></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.addendumItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconReportAddendum"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine">Addendum: <a class="item-details-trigger" data-id="', soy.$$escapeHtml(opt_data.item.docId), '">');
  el8.template.ptdata.reports.noteSummary(opt_data.referencedDoc, output);
  output.append('</a></div><div class="el8FeedColMainLine">', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.item.text)) : soy.$$escapeHtml(opt_data.item.text)), '</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.plrCollaboratorNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight plr-notification-item" data-id="', soy.$$escapeHtml(opt_data.item.id), '" ', (opt_data.item.careTeamInviteId) ? 'data-invite-id="' + soy.$$escapeHtml(opt_data.item.careTeamInviteId) + '"' : '', '><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon">', (opt_data.item.isCareTeamRelated) ? '<div class="el8FeedItemPLR4Everyone"></div>' : '<div class="el8ChartFeedIconBreakSeal"></div>', '</div><div class="el8FeedItemColMain">');
  el8.template.render.chartFeedItemNew.actionsSection(opt_data, output);
  output.append('<div class="el8FeedItemColMainTopLine">');
  el8.template.ptdata.plrCollaboratorNotifications.summary(opt_data.item, output);
  output.append('</div><div class="el8FeedColMainLine">');
  el8.template.ptdata.plrCollaboratorNotifications.displayEventType(opt_data.item, output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.plrImportableSource = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.sharerName) ? '<span class="el8PLRSourceSpan">' + soy.$$escapeHtml(opt_data.sharerName) + '</span>' : '', (opt_data.isConfidential) ? '<span class="el8ConfidentialSpan"><span class="el8BrandColor">Confidential</span><span class="el8FeedItemConfidentialIcon"></span></span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.actionsSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedItemColActions">');
  if (opt_data.isRA) {
    el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  } else {
    output.append('<a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.documentReminderNotificationItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconReminderAlertSigned"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions"><a class="el8FeedItemActionLinkNew chart-feed-actions-trigger-new" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '"><span class="el8FeedActionsLink">Actions</span></a></div><div class="el8FeedItemColMainTopLine el8Ellipsis"><a class="item-details-trigger" data-id="', soy.$$escapeHtml(opt_data.documentReminderNotification.reminder.order.id), '"><!-- Sleep to Generic order UI reskin -->', (opt_data.documentReminderNotification.reminder.forDocumentOrderType == 'sleep' && el8Globals.FEATURES.GenericOrder) ? 'Order' : (soy.$$escapeHtml(opt_data.documentReminderNotification.reminder.forDocumentOrderType)? soy.$$escapeHtml(opt_data.documentReminderNotification.reminder.forDocumentOrderType).capitalize() : '') + ' Order', ' Reminder</a>', (opt_data.documentReminderNotification.reminder.order.dateForTest) ? ' <span class="el8FontSmall el8999">Scheduled for: ' + (soy.$$escapeHtml(opt_data.documentReminderNotification.reminder.order.dateForTest)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentReminderNotification.reminder.order.dateForTest)) : '') + '</span>' : '', '</div><div class="el8FeedColMainLine">');
  el8.template.ptdata.model.order.orderFeedSummary({order: opt_data.documentReminderNotification.reminder.order, noExtraInfo: true}, output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.vipAccessNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight vip-access-notification-item" data-id="', soy.$$escapeHtml(opt_data.item.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconVIP"></div></div><div class="el8FeedItemColMain">');
  el8.template.render.chartFeedItemNew.actionsSection(opt_data, output);
  output.append('<div class="el8FeedItemColMainTopLine">', soy.$$escapeHtml(opt_data.item.accessingUserName), ' accessed patient\'s chart on ', (soy.$$escapeHtml(opt_data.item.accessDatetime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.item.accessDatetime)) : ''), ' at ', (soy.$$escapeHtml(opt_data.item.accessDatetime)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.item.accessDatetime)) : ''), '</div><div class="el8FeedColMainLine">VIP access notification</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.pmpCheckNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight pmp-check-notification-item" data-id="', soy.$$escapeHtml(opt_data.item.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconPmpCheck"></div></div><div class="el8FeedItemColMain">');
  el8.template.render.chartFeedItemNew.actionsSection(opt_data, output);
  output.append('<div class="el8FeedItemColMainTopLine">', soy.$$escapeHtml(opt_data.item.chartFeedText), '</div><div class="el8FeedColMainLine">PMP check notification</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.prenatalFlowsheetVisitMeasurements = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight prenatal-flowsheet-visit-measurements" data-id="', soy.$$escapeHtml(opt_data.visitMeasurements.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconPrenatalFS"></div></div><div class="el8FeedItemColMain">');
  el8.template.render.chartFeedItemNew.actionsSection(opt_data, output);
  output.append('<div class="el8FeedItemColMainTopLine"><a class="prenatal-flowsheet-display-trigger">');
  el8.template.ptdata.prenatalFlowsheets.feedSummary({visitMeasurements: opt_data.visitMeasurements, flowsheet: opt_data.flowsheet, isRA: opt_data.isRA}, output);
  output.append('</a></div><div class="el8FeedColMainLine">');
  el8.template.ptdata.prenatalFlowsheets.feedSummaryDetails({visitMeasurements: opt_data.visitMeasurements}, output);
  output.append('</div>');
  if (opt_data.visitMeasurements.signDate) {
    output.append('<div class="mb10">');
    el8.template.render.signOff.feedSummary(opt_data.visitMeasurements, output);
    output.append('</div>');
  }
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItemNew.reactItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew ', (opt_data.mClass == 'VisitNote2') ? 'el8FeedItemVisitNote' : '', ' am-highlight"></li>');
  if (!opt_sb) return output.toString();
};
